import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { path } from 'ramda'
import { isNullOrEmpty } from '@/utils'
import useProfile from '@/hooks/use-profile'
import useRole from '@/hooks/use-role'
import { showPaymentIncompleteModal } from './payment-incomplete-modal'

const PaymentIncompleteModal = () => {
  const [isOpen, setIsOpen] = useState(false)
  const data = useProfile()
  const isLandlord = useRole() === 'landlord'
  const session = useSelector(path(['session']))
  const userId = session?.session?.id
  const intendedPlan = session?.session?.intended_plan
  const intendedPlanId = session?.session?.intended_plan_flag_id
  const hasIntendedPlan = !isNullOrEmpty(intendedPlan)

  const exitModal = isOpen || !isLandlord || !session || !data.id || !hasIntendedPlan
  const showModal = userId && hasIntendedPlan && data.registration_complete === '1'
  const hideModal = exitModal || !showModal
  useEffect(() => {
    if (hideModal) return
    setIsOpen(true)
    showPaymentIncompleteModal({ intendedPlan: { plan: intendedPlan, id: intendedPlanId } })
  }, [hideModal, intendedPlan, intendedPlanId, hasIntendedPlan])
  return null
}

export default PaymentIncompleteModal
